import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center"},[(!_vm.hideIcon)?_c(VIcon,{attrs:{"size":"20","color":_vm.color}},[_vm._v(" mdi-alert ")]):_vm._e(),_c('span',{staticClass:"warning-message ml-2",style:({'color': _vm.color})},[_vm._v(_vm._s(_vm.message))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }